<script setup lang="ts">
  import { useToastStore } from '@/stores/toast'

  const toast = useToastStore()

  const newToast = (message: string) => {
    toast.items.push({ message, id: Date.now().toString() })
    // 3s + 10ms per letters up to 5s
    const duration = Math.min(3000 + message.length * 10, 5000)
    setTimeout(() => {
      toast.items.shift()
    }, duration)
  }

  defineExpose({ newToast })
</script>

<template>
  <div class="toast-wrapper">
    <transition-group name="toast">
      <div
        v-for="item in toast.items"
        :key="item.id"
        class="toast-items">
        {{ item.message }}
      </div>
    </transition-group>
  </div>
</template>

<style lang="postcss" scoped>
  .toast-wrapper {
    @apply pointer-events-none fixed inset-x-0 bottom-4 z-50 flex flex-col;

    .toast-items {
      @apply mx-auto mb-2 max-w-screen-sm px-4 py-1;
      @apply bg-black bg-opacity-50 text-xs text-white;

      transition:
        all 0.2s ease,
        opacity 0.5s ease;
    }

    .toast-enter-from,
    .toast-leave-to {
      opacity: 0;
    }
  }
</style>
